import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

interface ConfirmationDialogProps {
  isOpen: boolean;
  toggle: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonColor?: string;
  icon?: string;
  type?: 'warning' | 'danger' | 'info' | 'success';
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  toggle,
  onConfirm,
  title = 'Confirmation',
  message,
  confirmText = 'Yes, Continue',
  cancelText = 'Cancel',
  confirmButtonColor = 'primary',
  icon = 'fa-solid fa-question-circle',
  type = 'warning'
}) => {
  const handleConfirm = () => {
    onConfirm();
    toggle();
  };

  const getTypeStyles = () => {
    switch (type) {
      case 'warning':
        return {
          iconColor: 'text-warning',
          borderColor: 'border-warning',
          confirmColor: 'warning'
        };
      case 'danger':
        return {
          iconColor: 'text-danger',
          borderColor: 'border-danger',
          confirmColor: 'danger'
        };
      case 'info':
        return {
          iconColor: 'text-info',
          borderColor: 'border-info',
          confirmColor: 'info'
        };
      case 'success':
        return {
          iconColor: 'text-success',
          borderColor: 'border-success',
          confirmColor: 'success'
        };
      default:
        return {
          iconColor: 'text-warning',
          borderColor: 'border-warning',
          confirmColor: 'warning'
        };
    }
  };

  const typeStyles = getTypeStyles();

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle} className={`${typeStyles.borderColor} border-bottom-2`}>
        <div className="d-flex align-items-center">
          <i className={`${icon} ${typeStyles.iconColor} me-2 fs-4`}></i>
          <h4 className="mb-0">{title}</h4>
        </div>
      </ModalHeader>
      
      <ModalBody className="py-4">
        <div className="text-center">
          <div className="confirmation-icon mb-3">
            <i className={`${icon} ${typeStyles.iconColor} fs-1 opacity-75`}></i>
          </div>
          <p className="fs-6 text-muted mb-0" dangerouslySetInnerHTML={{ __html: message }}></p>
        </div>
      </ModalBody>
      
      <ModalFooter className="border-top-0 pt-0">
        <div className="d-flex gap-2 w-100">
          <Button 
            color="secondary" 
            onClick={toggle}
            className="flex-fill"
            outline
          >
            {cancelText}
          </Button>
          <Button 
            color={confirmButtonColor || typeStyles.confirmColor} 
            onClick={handleConfirm}
            className="flex-fill"
          >
            {confirmText}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationDialog;
